<template>
  <sidenav :orientation="orientation" :class="curClasses">
    <!-- Brand -->
    <div class="app-brand py-3">
      <router-link to="/" class="d-block w-100">
        <img src="/images/logo.png" alt class="app-brand-img" />
        <img
          src="/images/logo-small.png"
          alt
          class="app-brand-img-collapsed mx-auto"
        />
      </router-link>
      <a
        href="javascript:void(0)"
        class="layout-sidenav-toggle sidenav-link text-large ml-auto"
        @click="toggleSidenav()"
      >
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <!-- / Brand -->
    <!-- Inner -->
    <div
      class="sidenav-inner"
      :class="{ 'py-1': orientation !== 'horizontal' }"
    >
      <sidenav-router-link icon="ion ion-md-analytics" to="/" :exact="true"
        >Overview</sidenav-router-link
      >
      <sidenav-router-link
        icon="ion ion-md-trending-up"
        to="/trends"
        :exact="true"
      >
        Trends
      </sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-cart" to="/sales" :exact="true"
        >Sales</sidenav-router-link
      >
      <sidenav-menu
        icon="ion ion-ios-cog"
        :active="
          isMenuActive('/machines') || isMenuActive('/machines/archived')
        "
        :open="isMenuOpen('/machines') || isMenuOpen('/machines/archived')"
      >
        <template slot="link-text">Machines</template>
        <sidenav-router-link to="/machines" :exact="false">
          Machines
        </sidenav-router-link>
        <sidenav-router-link to="/machines/archived" :exact="false">
          Archived
        </sidenav-router-link>
      </sidenav-menu>
      <sidenav-router-link icon="ion ion-md-cube" to="/groups" :exact="false" v-if="this.hasGroupClaims">
        Groups
      </sidenav-router-link>
      <sidenav-menu
        icon="ion ion-ios-beaker"
        :active="
          isMenuActive('/products') ||
            isMenuActive('/planograms') ||
            isMenuActive('/priceLists')
        "
        :open="
          isMenuOpen('/products') ||
            isMenuOpen('/planograms') ||
            isMenuOpen('/priceLists')
        "
      >
        <template slot="link-text">Products</template>
        <sidenav-router-link to="/products" :exact="false">
          Products
        </sidenav-router-link>
        <sidenav-router-link to="/planograms" :exact="false">
          Planograms
        </sidenav-router-link>
        <sidenav-router-link to="/priceLists" :exact="false">
          Price Lists
        </sidenav-router-link>
      </sidenav-menu>
      <sidenav-router-link
        icon="ion ion-ios-flash"
        to="/attracts"
        :exact="false"
      >
        Attracts
      </sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-build" to="/service" :exact="true">
        Service
      </sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-contacts" to="/users" :exact="true" v-if="this.hasUserClaims">
        Users
      </sidenav-router-link>
    </div>
  </sidenav>
</template>

<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider
} from "@/vendor/libs/sidenav";

export default {
  name: "app-layout-sidenav",
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: "vertical"
    }
  },

  data() {
    return {
      hasUserClaims: false,
      hasGroupClaims: false
    };
  },

  created() {

    this.loadData();

  },

  computed: {
    curClasses() {
      let bg = this.layoutSidenavBg;

      if (
        this.orientation === "horizontal" &&
        (bg.indexOf(" sidenav-dark") !== -1 ||
          bg.indexOf(" sidenav-light") !== -1)
      ) {
        bg = bg
          .replace(" sidenav-dark", "")
          .replace(" sidenav-light", "")
          .replace("-darker", "")
          .replace("-dark", "");
      }

      return (
        `bg-${bg} ` +
        (this.orientation !== "horizontal"
          ? "layout-sidenav"
          : "layout-sidenav-horizontal container-p-x flex-grow-0")
      );
    }
  },

  methods: {
    isMenuActive(url) {
      return this.$route.path.indexOf(url) === 0;
    },

    isMenuOpen(url) {
      return (
        this.$route.path.indexOf(url) === 0 && this.orientation !== "horizontal"
      );
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },

    async loadData() {
      var claims = await this.$auth.getAuthTokenClaims();
      this.hasUserClaims = claims.find(x => x.startsWith("user:"));
      this.hasGroupClaims = claims.find(x => x.startsWith("group:"));
    }
  }
};
</script>
